import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredString } from '@/utils/zodUtils';

export const SalePointAndProductSchema = (t: GetTextIdTranslationType) =>
  z.object({
    salePoint: requiredString(t),
    campaign: requiredString(t),
  });

export type SalePointAndProductFormData = z.infer<ReturnType<typeof SalePointAndProductSchema>>;
